module.exports = __webpack_public_path__ + "img/max-file-transfer--pdf.9e9cd27c.svg";